<template>
	<div>
		<div class="col-md-12">
			<div class="card abtg__default-card abtg__default-card-border">
				<div class="card-head">
					<header>{{$t('todo.list_title')}}</header>
					<div class="abtg__header_popover">
						<popover module="todo"
						         content="todo"
						         color="grey"
						         position="right"></popover>
					</div>
					<div class="tools">

					</div>
				</div>
				<div class="card-body ">

					<div class="col-md-12">
						<form @submit.prevent="onSubmit()">
							<div class="row"
							     v-if="$route.params.id > 0">
								<div class="col">
									<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
									     style="padding-right: 0px;">
										<input class="mdl-textfield__input abtg__input"
										       name="description"
										       type="text"
										       v-model="description">
										<label class="mdl-textfield__label">{{$t('todo.label_description')}}</label>
									</div>
								</div>

							</div>
							<div class="row"
							     v-else>
								<p v-html="$t('custom.await_todo')"></p>
							</div>

							<div class="row">
								<div class="col">&nbsp;</div>
							</div>
							<div class="row"
							     v-if="$route.params.id > 0">
								<div class="col">
									<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select getmdl-select__fix-height select-width abtg-select">
										<label for="city_id"
										       class=" abtg__label-select">Assegna a:</label>
										<select class="mdl-textfield__input abtg__input abtg-select"
										        tabIndex="-1"
										        id="city_id"
										        v-model="teamId"
										        v-if="teamListData.length > 0">
											<option v-for="(t, index) in teamListData"
											        :key="index"
											        :value="t.id">
												{{t.name.length > 0 ? t.name : t.email}} 
											</option>

										</select>
										<p v-else>Componi il tuo team nella scheda "Il mio team"</p>

									</div>
								</div>

								<div class="col"
								     v-if="teamListData.length > 0">
									<div style="margin-top:-20px;">
										<div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
										     style="padding-right: 0px; ">

											<date-picker v-model="date"
											             lang="it"
											             placeholder=""
											             format="DD/MM/YYYY"></date-picker>

											<label class="mdl-textfield__label"
											       style="margin-top:-20px;">Scadenza</label>

										</div>
									</div>
								</div>

								<div class="col"
								     v-if="teamListData.length > 0">
									<div style="margin-top:-20px;">
										<button class=" m-t-20 margin-right-10 btn btn-default float-right      shadow-none abtg__btn-star">
											Aggiungi
										</button>
									</div>
								</div>

							</div>

						</form>
					</div>

					<hr>

					<div class="table-responsive">
						<table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table   is-upgraded  "
						       v-if="typeof toDoList !== undefined && toDoList.length > 0">
							<thead>
								<tr>
									<th class="mdl-data-table__cell--non-numeric text-left"></th>
									<th></th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(t, index) in toDoList" :key="index">
									<td>
										<input type="checkbox"
										       name="done"
										       id="checkbox-1"
										       class=""
										       :value="t.id"
										       v-model="t.done"
										       @click="isItCompleted(
                                               {
                                                id: t.id,
                                                resourceId: $route.params.id,
                                                type: rounte.params.type
                                                }
                                           )">

									</td>
									<td :class="isStriked(t.done)">
										<p>{{t.description}}<br>
											<i class="far fa-calendar-alt"></i> {{t.deadLine}}&nbsp;&nbsp;&nbsp;
											<i class="fas fa-user abtg__color"></i> {{t.assignedTo}}</p>
									</td>

									<td>
										<a data-toggle="modal"
										   data-target="#exampleModal"
										   @click="populateDataToSend(t)">
											<i class="far fa-trash-alt "></i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>

					</div>
				</div>
			</div>
		</div>

		<!-- start modal -->
		<div class="modal fade"
		     id="exampleModal"
		     tabindex="-1"
		     role="dialog"
		     aria-labelledby="exampleModalLabel"
		     aria-hidden="true">
			<div class="modal-dialog"
			     role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title"
						    id="exampleModalLabel">
							{{$t('todo.question_title')}}</h4>
						<button type="button"
						        class="close"
						        data-dismiss="modal"
						        aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						{{$t('todo.question')}}
					</div>
					<div class="modal-footer">
						<button type="button"
						        class="btn btn-secondary"
						        data-dismiss="modal">
							{{$t('valutation.valutation_label_button_close')}}
						</button>
						<button type="button"
						        class="btn btn-success"
						        @click="deleteToDo({id:idToDelete})"
						        data-dismiss="modal">{{$t('valutation.valutation_label_button_delete')}}
						</button>
					</div>
				</div>
			</div>
		</div>
		<!-- end modal -->

	</div>

</template>
<script>
	import { mixin } from '@/helpers/helper'
	import { roles } from '@/helpers/roles'
	import Popover from '@/partials/popover'
	import DatePicker from 'vue2-datepicker'

	import { mapActions, mapState } from 'vuex'

	export default {
		mixins: [mixin, roles],
		components: { Popover, DatePicker },
		props: ['id', 'type', 'colorBar', 'colorHeader'],
		data: function() {
			return {
				selected: [],
				idToDelete: null,
				description: '',
				teamId: 0,
				date: '',
				done: 0,
			}
		},

		computed: {
			...mapState('n_todo', ['todoList', 'teamListData']),
		},
		created: function() {
			this.listData({ resourceId: this.$route.params.id, type: 3 })
		},
		methods: {
			...mapActions('n_todo', ['listData', 'save', 'deleteToDo', 'isItCompleted']),

			onSubmit: function() {
				this.save({
					description: this.description,
					done: this.done,
					resourceId: this.id,
					type: this.type,
					teamId: this.teamId,
					date: this.date,
				})
				this.description = ''
				this.teamId = 0
				this.date = ''
			},

			populateDataToSend: function(t) {
				this.idToDelete = t.id
			},
			isStriked: function(done) {
				if (done === 1) {
					return 'abtg__strike '
				}
			},
		},
	}
</script>
